angular.module('portal-common', []);
(function () {
    'use strict';

    navitemCtrl.$inject = ['$location', '$document'];
    angular
        .module('portal-common')
        .directive('coverNavitem', navitem);

    function navitem() {
        return {
            restrict: 'E',
            scope: {
                item: '='
            },
            controller: navitemCtrl,
            controllerAs: 'vm',
            bindToController: true,
            template: '<a ng-if="vm.item.link" ng-bind-html="vm.item.label" ng-if="vm.item.link" ng-click="vm.clickHref(vm.item.link)" target="<% vm.item.target || \'_self\'%>"></a>'
        };
    }

    function navitemCtrl($location, $document) {
        var vm = this;
        this.$onInit = function() {
            vm.clickHref = clickHref;
        }

        function clickHref(href) {
            if (href.indexOf('//') >= 0) {
                openExternal(href, vm.item.target);
            } else {
                $location.path(href);
            }
            $document.focus();
        }

        function openExternal(link, target) {
            window.open(link, target);
        }
    }
})();

angular.module('jobboard', ['PortalControllers','sodCommon', 'portal-common']);

angular.module('PortalControllers',['ngRoute']);
angular.module('jobseeker-portal', ['PortalControllers','sodCommon', 'portal-common']);
angular.module('rms-portal', ['PortalControllers','sodCommon', 'portal-common', 'rms.common']);

(function() {
    'use strict';
    configFunc.$inject = ['$routeProvider', '$locationProvider'];
    angular
        .module('PortalControllers')
        .config(configFunc);

    function configFunc($routeProvider, $locationProvider) {
        $routeProvider
            .when('/*', {
                template: '<div layout-generator="layoutGenerator"></div>',
                resolve: {
                    load: function() {
                    }
                }
            });
        $locationProvider.html5Mode(true);
    }
})();
(function() {
    'use strict';

    ttGridFilterTabCtrl.$inject = ['$scope', 'lodash', '$timeout'];
    angular
        .module('PortalControllers')
        .directive('ttGridFilterTab', ttGridFilterTab);

    function ttGridFilterTab() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                labels: '='
            },
            //templateUrl: '/api/admin/portal/templates/customPortalFilter',
            templateUrl: 'common/portal/customPortalFilter',
            controller: ttGridFilterTabCtrl,
            link: ttGridFilterTabLink
        };

        function ttGridFilterTabLink (scope){
            scope.pristineState = angular.copy(scope.filterModel);
        }
    }

    function ttGridFilterTabCtrl($scope, lodash, $timeout) {
        this.$onInit = function() {

            $scope.filters = $scope.options.filters;
            var pageStartIndex = $scope.options.grid.pageStartIndex || 1;

            $scope.grid = angular.merge($scope.options.grid, {
                datasource: {
                    transport: {
                        parameterMap: function (data, type) {
                            if (type == 'read') {
                                var filter = angular.element('form').serializeArray();
                                if (filter.length > 0) {
                                    data.filter = filter.map(function (item) {
                                        return item.name + "=" + item.value;
                                    }).join('&');
                                }
                                data.page = data.page + pageStartIndex - 1 || pageStartIndex;
                                data.pageSize = data.pageSize || 10;
                            }
                            return data;
                        }
                    },
                    change: function () {
                        $scope.job_count = this.total();
                        $scope.$apply();
                    }
                }
            });

            if ($scope.filters) {
                $scope.appliedFilter = false;
                $scope.showFilter = true;
                $scope.filterModel = {};
                for (var i in $scope.filters) {
                    if ($scope.filters[i].type == 'dropdown') {
                        $scope.filterModel[$scope.filters[i].name] = [];
                    } else {
                        $scope.filterModel[$scope.filters[i].name] = {};
                    }

                }

                $scope.default = $scope.filters[Object.keys($scope.filters)[0]];
                $scope.active = null;

                $scope.toggleFilter = toggleFilter;
                $scope.clearFilter = clearFilter;
                $scope.isCheckbox = isCheckbox;
                $scope.isSelect =isSelect;
                $scope.isActive = isActive;
                $scope.activeCount = activeCount;
                $scope.filterClass = filterClass;
                $scope.setActive = setActive;
                $scope.getMultiselectOption = getMultiselectOption;
            }

            $scope.queryDb = queryDb;
            $scope.checkboxChanged = checkboxChanged;
            $scope.changeGrouping = changeGrouping;

            if (lodash.has($scope.options, 'groups')) {
                $scope.activeGroup = angular.copy(lodash.find($scope.options.groups, function (item) {
                    return (item.active) ? item : null;
                }));

                $scope.toggleGrouping = toggleGrouping;
                $scope.getActiveGroupClass = getActiveGroupClass;
                $scope.toggleGroupingClass = toggleGroupingClass;
                $scope.removeGroup = removeGroup;
            }

        }
        function toggleFilter() {
            $scope.showFilter = !$scope.showFilter;
        }

        function clearFilter() {
            $scope.filterModel = angular.copy($scope.pristineState);
            $scope.filterform.$setPristine();
            var timeoutPromise = $timeout(function () {
                $scope.jobsGrid.dataSource.page(1);
                $timeout.cancel(timeoutPromise);
            }, 250);
        }

        function isCheckbox(filter) {
            return filter.type == 'checkbox';
        }

        function isSelect(filter) {
            return filter.type == 'dropdown';
        }

        function isActive(filter) {
            var active = (function () {
                if ($scope.active == null) {
                    return filter.name == $scope.default.name;
                } else {
                    return filter.name == $scope.active.name;
                }
            })();

            return (active) ? "active" : '';
        }

        function activeCount() {
            var _filter = angular.element('form').serializeArray();
            var index = [];

            for (var i in _filter) {
                if (!(index.indexOf(_filter[i].name) >= 0)) {
                    index.push(_filter[i].name);
                }
            }

            return index.length;
        }

        function filterClass(filter) {
            var activeClass = $scope.isActive(filter);

            var _filter = angular.element('form').serializeArray();
            if (_filter.length > 0) {
                var res = lodash.find(_filter, function(item) {
                    return item.name.indexOf(filter.name) >= 0;
                });
            }

            if (res) {
                activeClass += ' selected';
            }

            return activeClass;
        }

        function setActive(filter) {
            $scope.active = filter;
        }

        function getMultiselectOption(filter) {
            return {
                dataSource: {
                    data: filter.data
                },
                dataTextField: 'label',
                dataValueField: 'value',
                change: function () {
                    $scope.jobsGrid.dataSource.read();
                }
            };
        }

        function queryDb() {
            var filter = angular.element('form').serialize();
            if (filter.length > 0) {
                $scope.jobsGrid.dataSource.query({filter: filter});
            } else {
                $scope.jobsGrid.dataSource.query();
            }
        }

        function checkboxChanged() {
            $scope.jobsGrid.dataSource.read();
        }

        function changeGrouping(field, dir) {
            var order = {
                field: field,
                dir: dir
            };
            $scope.jobsGrid.dataSource.group(order).page(1);
        }

        function toggleGrouping(group) {
            //group.dir =
            if ($scope.activeGroup == null) {
                $scope.activeGroup = angular.copy(group);
            } else {
                if ($scope.activeGroup.field == group.field) {
                    $scope.activeGroup.dir = ($scope.activeGroup.dir == 'asc') ? 'desc' : 'asc';
                } else {
                    $scope.activeGroup = angular.copy(group);
                }
            }

            $scope.jobsGrid.dataSource.group({
                field: $scope.activeGroup.field,
                dir: $scope.activeGroup.dir
            });
            $scope.jobsGrid.dataSource.page(1);
        }

        function getActiveGroupClass(group) {
            if (typeof $scope.activeGroup == typeof undefined) return "";
            if ($scope.activeGroup == null) return "";
            return (group.field == $scope.activeGroup.field) ? 'active' : "";
        }

        function toggleGroupingClass(group) {
            if (typeof $scope.activeGroup == typeof undefined) return "";
            if ($scope.activeGroup == null) return "";
            if (group.field == $scope.activeGroup.field) {
                return ($scope.activeGroup.dir == 'asc') ? "fa-arrow-up" : "fa-arrow-down";
            }
            return "";
        }

        function removeGroup($event) {
            $event.stopPropagation();
            $scope.activeGroup = null;
            $scope.jobsGrid.dataSource.group([]);
            $scope.jobsGrid.dataSource.page(1);
        }
    }
})();
(function () {
    'use strict';

    rmsFilter.$inject = ['FormBuilderService', '$timeout', 'ListFilterStateFactory', 'lodash'];
    rmsFilterCtrl.$inject = ['$scope', 'lodash'];
    angular
        .module('rms-portal')
        .directive('rmsFilter', rmsFilter);

    function rmsFilter(FormBuilderService, $timeout, ListFilterStateFactory, lodash) {
        return {
            restrict: 'E',
            controller: rmsFilterCtrl,
            scope: {
                options: '=',
                filterForm: '=?',
            },
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'rms-career/components/rms-filter',
            link: function(scope, elem) {
                const vm = scope.vm;
                const showFilterButton = elem.find('.show-advance-filters');
                const advanceSearch = elem.find('.advanced-search');

                vm.onShowButtonClick = onShowButtonClick;
                vm.onSortChange = onSortChange;
                vm.searchTextChanged = searchTextChanged;

                $timeout(function() {
                    // const fbService = FormBuilderService.get(vm.filterForm.name);
                    scope.listFilterService = ListFilterStateFactory.get(scope.listFilterIdentifier);
                    scope.$watch(function() {
                        return FormBuilderService.getModel(vm.filterForm.name);
                    }, function() {
                        // do refresh grid
                        const filters = generateFilters();
                        scope.listFilterService.getFilterService().setActiveFilter('applied', filters);
                        generateSort();
                        scope.listFilterService.refreshGrid();
                    }, true);
                });

                function onShowButtonClick() {
                    if (showFilterButton.hasClass('active')) {
                        showFilterButton.removeClass('active');
                        advanceSearch.slideUp();
                    } else {
                        showFilterButton.addClass('active');
                        advanceSearch.slideDown();
                    }
                }

                function generateFilters() {
                    const formModel = FormBuilderService.getModel(vm.filterForm.name);
                    const formModelNotEmpty = lodash.omitBy(formModel, function(value) {
                       if (lodash.isNumber(value)) {
                           return false;
                       }
                       return lodash.isEmpty(value);
                    });
                    const modelKeys = lodash.keys(lodash.omit(formModelNotEmpty, ['hid_ref_form']));

                    return modelKeys.map(function(key) {
                       var modelValue =formModel[key];
                        if (!lodash.isArray(modelValue)) {
                            modelValue = [modelValue];
                        }
                       return {
                           field: key,
                           operator: 'in',
                           value: modelValue,
                       };
                    });
                }

                function onSortChange() {
                    // console.log('sort change', vm.sortBy);
                    generateSort();
                    scope.listFilterService.refreshGrid();
                    //scope.listFilterService.getGrid().dataSource.sort();
                }

                function generateSort(){
                    if (!vm.sortBy) {
                        vm.sortBy = lodash.get(vm.options,'sort_by.default_sort',null);
                    }
                    if (vm.sortBy) {
                        const sort = vm.sortBy.split('|');
                        scope.listFilterService.getGrid().dataSource.sort({field: sort[0], dir: sort[1]});
                    } else {
                        //use default
                        scope.listFilterService.getGrid().dataSource.sort({});
                    }
                }
                
                function searchTextChanged() {
                    scope.listFilterService.setSearchText(vm.searchText);
                    scope.listFilterService.refreshGrid();
                }
            }
        };
    }

    function rmsFilterCtrl($scope, lodash) {
        const vm = this;
        this.$onInit = function() {
            $scope.listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');
        }
    }
})();
(function() {
    'use strict';

    tessShareThis.$inject = ['$timeout'];
    angular
        .module('jobseeker-portal')
        .directive('tessShareThis', tessShareThis);

    function tessShareThis($timeout) {
        return {
            restrict: 'A',
            link: function() {
                stButtons.locateElements();
                $timeout(function() {
                   console.log(1);
                   console.log(2);
                });
            }
        };
    }
})();
(function() {
    'use strict';

    runFunc.$inject = ['$http', '$q', '$rootScope', 'Path', 'MasterLayoutService'];
    angular
        .module('jobboard')
        .run(runFunc);

    function runFunc($http, $q, $rootScope, Path, MasterLayoutService) {
        // $q.defer() allow us to delay processing until they are done processing.
        var masterTemplateDataDefer = $q.defer();
        $rootScope.initPortalLoader = $q.defer();

        angular.element('.no-js-wrapper').remove();

        Path.init('/api/admin/jobboard/structure/', '/api');

        var navUrl = '/api/admin/shared/structure/navbar';
        Path.setMasterLayoutDataPath(navUrl);
        $http.get(navUrl).then(function (res) {
            if (res.data.success) {
                MasterLayoutService.set(res.data.structure);
            }
            masterTemplateDataDefer.resolve();
        }, function () {
            masterTemplateDataDefer.resolve();
        });

        $q.all([masterTemplateDataDefer.promise]).then(function () {
            $rootScope.initPortalLoader.resolve();
        });

    }
})();
(function() {
    'use strict';

    runFunc.$inject = ['$http', '$q', '$rootScope', 'Path', 'MasterLayoutService'];
    angular
        .module('jobseeker-portal')
        .run(runFunc);

    function runFunc($http, $q, $rootScope, Path, MasterLayoutService) {
        // $q.defer() allow us to delay processing until they are done processing.
        var masterTemplateDataDefer = $q.defer();
        $rootScope.initPortalLoader = $q.defer();

        angular.element('.no-js-wrapper').remove();

        Path.init('/api/admin/portal/structure/', '/api');

        var navUrl = '/api/admin/shared/structure/navbar';
        Path.setMasterLayoutDataPath(navUrl);
        $http.get(navUrl).then(function (res) {
            if (res.data.success) {
                MasterLayoutService.set(res.data.structure);
            }
            masterTemplateDataDefer.resolve();
        }, function () {
            masterTemplateDataDefer.resolve();
        });

        $q.all([masterTemplateDataDefer.promise]).then(function () {
            $rootScope.initPortalLoader.resolve();
        });

    }
})();
(function() {
    'use strict';

    runFunc.$inject = ['$http', '$q', '$rootScope', 'Path', 'MasterLayoutService'];
    angular
        .module('rms-portal')
        .run(runFunc);

    function runFunc($http, $q, $rootScope, Path, MasterLayoutService) {
        // $q.defer() allow us to delay processing until they are done processing.
        var masterTemplateDataDefer = $q.defer();
        $rootScope.initPortalLoader = $q.defer();

        angular.element('.no-js-wrapper').remove();

        Path.init('/api/admin/rms/structure/', '/api');
        $rootScope.initPortalLoader.resolve();
    }
})();